export default `
query getCatalogDiscountText($sku : String!) {
  catalogDiscountText(product_sku: $sku) {
      product_sku
      discount_text
      is_available
      discount_image
  }
}`;
